// extracted by mini-css-extract-plugin
export default {"root":"BootstrapAccordion_root__+sMHa","accordionButton":"BootstrapAccordion_accordionButton__VeTgp"};